import { Users } from "lucide-react";

export default function ParticipatingTeams({teams}) {

  return (
    <div className="mb-6">
      <div className="rounded-2xl border border-gray-200/50 dark:border-gray-700/50 bg-white/80 dark:bg-gray-900/80 backdrop-blur shadow-lg">

        <div className="p-4">

          {/* Header */}
          <div className="flex items-center gap-2 mb-4">

            <Users className="w-4 h-4 text-blue-500" />

            <h2 className="text-lg font-bold bg-gradient-to-r from-blue-500 to-purple-500 bg-clip-text text-transparent">
              Participating Teams
            </h2>

            <span className="ml-auto text-[10px] px-2 py-1 rounded-full font-semibold bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300">
              {teams.length}
            </span>

          </div>

          {/* Team Grid */}
          <div
            className="
              grid
              grid-cols-4
              sm:grid-cols-5
              md:grid-cols-6
              lg:grid-cols-8
              xl:grid-cols-10
              gap-2
            "
          >
            {teams.map((team, index) => (
              <div
                key={index}
                className="
                  flex
                  flex-col
                  items-center
                  p-2
                  rounded-xl
                  bg-gray-50/70
                  dark:bg-gray-800/40
                  border
                  border-gray-200/50
                  dark:border-gray-700/50
                  hover:border-blue-500
                  transition-all
                  duration-300
                  cursor-pointer
                "
              >
                <div
                  className="
                    w-8
                    h-8
                    rounded-lg
                    p-0.5
                    mb-1
                    border
                    border-gray-200/50
                    dark:border-gray-700/50
                    bg-gray-200
                    dark:bg-gray-700
                  "
                >
                  <img
                    src={team.team_badge}
                    alt={team.team_name}
                    className="w-full h-full object-contain"
                  />
                </div>

                <span
                  className="
                    text-[10px]
                    font-medium
                    text-center
                    leading-tight
                    text-gray-800
                    dark:text-gray-200
                    line-clamp-2
                  "
                >
                  {team.team_name}
                </span>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  );
}